<template>
    <div class="container mt-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2>Gestión de Ubicaciones</h2>
        <!-- Botón para crear una nueva ubicación -->
        <button class="btn btn-primary" @click="nuevaUbicacion">Nueva Ubicación</button>
      </div>
  
      <!-- Listado de ubicaciones -->
      <table class="table">
        <thead>
          <tr>
            <th>Pais</th>
            <th>Región</th>
            <th>Ciudad</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ubicacion in ubicacionesPaginadas" :key="ubicacion.id">
            <td>{{ ubicacion.pais }}</td>
            <td>{{ ubicacion.region }}</td>
            <td>{{ ubicacion.ciudad }}</td>
            <td>
              <button class="btn btn-outline-primary me-2" @click="editarUbicacion(ubicacion)">Editar</button>
              <button class="btn btn-outline-danger" @click="eliminarUbicacion(ubicacion.id)">Eliminar</button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- Paginación -->
      <nav>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="cambiarPagina(paginaActual - 1)">Anterior</a>
          </li>
          <li class="page-item" v-for="pagina in totalPaginas" :key="pagina" :class="{ active: pagina === paginaActual }">
            <a class="page-link" href="#" @click.prevent="cambiarPagina(pagina)">{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <a class="page-link" href="#" @click.prevent="cambiarPagina(paginaActual + 1)">Siguiente</a>
          </li>
        </ul>
      </nav>
    </div>

    <router-view />

  </template>
  
  <script>
  import axios from '@/axios';
  export default {
    data() {
      return {
        ubicaciones: [],
        ubicacionSeleccionada: null,
        mostrarFormulario: false,
        paginaActual: 1,
        ubicacionesPorPagina: 10, // Número de ubicaciones por página
        clubActual: this.$store.getters.getClubActual,
      };
    },
    computed: {
      // Cálculo de ubicaciones por página
      ubicacionesPaginadas() {
        const inicio = (this.paginaActual - 1) * this.ubicacionesPorPagina;
        const fin = inicio + this.ubicacionesPorPagina;
        return this.ubicaciones.slice(inicio, fin);
      },
      totalPaginas() {
        return Math.ceil(this.ubicaciones.length / this.ubicacionesPorPagina);
      },
    },
    methods: {
      async cargarUbicaciones() {
        try {
          const response = await axios.get('/api/ubicaciones', {
            params: {
              club_id: this.clubActual.id,
            },
          });
          this.ubicaciones = response.data;
        } catch (error) {
          console.error('Error al cargar las ubicaciones:', error);
        }
      },
      editarUbicacion(ubicacion) {
        this.$router.push({ name: 'EditarUbicacion', params: { id: ubicacion.id } });
      },
      nuevaUbicacion() {
        this.$router.push({ name: 'AltaUbicacion' });
      },
      async eliminarUbicacion(id) {
        if (confirm('¿Estás seguro de eliminar esta ubicación?')) {
          try {
            await axios.delete(`/api/ubicaciones/${id}`, {data: { club_id: this.clubActual.id }});
            this.cargarUbicaciones();
          } catch (error) {
            console.error('Error al eliminar la ubicación:', error);
          }
        }
      },
      cambiarPagina(pagina) {
        if (pagina > 0 && pagina <= this.totalPaginas) {
          this.paginaActual = pagina;
        }
      },
    },
    mounted() {
      this.cargarUbicaciones();
    },
  };
  </script>
  